import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../lib/api";
import { Card } from "../components/shared";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Search, ScrollText } from "lucide-react";

export default function Auditoria() {
  const { pid } = useParams();
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  const [usuario, setUsuario] = useState("");
  const [usuarios, setUsuarios] = useState([]);

  const load = () => {
    const params = new URLSearchParams();
    if (q) params.set("q", q);
    if (usuario) params.set("usuario", usuario);
    api.get(`/properties/${pid}/auditoria?${params}`).then((r) => {
      setItems(r.data);
      setUsuarios((prev) => [...new Set([...prev, ...r.data.map((a) => a.usuario)])]);
    });
  };
  useEffect(() => { load(); }, [pid, q, usuario]); // eslint-disable-line

  return (
    <div className="p-4 sm:p-8 max-w-[1100px]">
      <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="mb-6">
        <p className="text-xs tracking-[0.25em] uppercase text-[#00A3B5] font-bold mb-1">Trazabilidad total · Bitácora inmutable</p>
        <h1 className="font-display text-3xl font-bold text-[#002B49]">Auditoría</h1>
        <p className="text-sm text-slate-500 mt-1">Quién, qué, cuándo, valor anterior → nuevo. Sustituye promesas verbales sin evidencia auditable.</p>
      </motion.div>
      <div className="flex gap-3 mb-5">
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input data-testid="auditoria-buscar" placeholder="Buscar por trámite, acción o comentario..." value={q}
            onChange={(e) => setQ(e.target.value)} className="pl-9 w-72 h-9 bg-white" />
        </div>
        <Select value={usuario || "todos"} onValueChange={(v) => setUsuario(v === "todos" ? "" : v)}>
          <SelectTrigger data-testid="auditoria-usuario-filtro" className="w-56 h-9 bg-white"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="todos">Todos los usuarios</SelectItem>
            {usuarios.map((u) => <SelectItem key={u} value={u}>{u}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {!items ? <p className="text-slate-400 animate-pulse">Cargando bitácora...</p> : (
        <Card className="overflow-hidden" testId="auditoria-tabla">
          <div className="overflow-x-auto">
          <table className="w-full text-sm min-w-[760px]">
            <thead>
              <tr className="bg-slate-50 text-left text-xs uppercase tracking-wider text-slate-500">
                <th className="px-4 py-3">Fecha y hora</th><th className="px-4 py-3">Usuario</th>
                <th className="px-4 py-3">Acción</th><th className="px-4 py-3">Entidad</th>
                <th className="px-4 py-3">Cambio</th>
              </tr>
            </thead>
            <tbody>
              {items.map((a) => (
                <tr key={a.id} className="border-b border-slate-100 hover:bg-slate-50 transition-colors align-top">
                  <td className="px-4 py-3 text-slate-500 whitespace-nowrap text-xs">{new Date(a.timestamp).toLocaleString("es-MX")}</td>
                  <td className="px-4 py-3 font-semibold text-slate-700 text-xs">{a.usuario}</td>
                  <td className="px-4 py-3 text-slate-700 text-xs">{a.accion}</td>
                  <td className="px-4 py-3 text-slate-500 text-xs max-w-[200px] truncate">{a.entidad_nombre}</td>
                  <td className="px-4 py-3 text-xs max-w-[260px]">
                    {(a.valor_anterior || a.valor_nuevo) && (
                      <span>
                        {a.valor_anterior && <span className="text-slate-400 line-through">{a.valor_anterior}</span>}
                        {a.valor_anterior && " → "}
                        <span className="text-[#002B49] font-semibold">{a.valor_nuevo}</span>
                      </span>
                    )}
                    {a.comentario && <p className="text-slate-400 italic mt-0.5">"{a.comentario}"</p>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
          {items.length === 0 && (
            <div className="p-10 text-center text-slate-400">
              <ScrollText size={28} className="mx-auto mb-2 text-slate-300" />Sin registros que coincidan.
            </div>
          )}
        </Card>
      )}
    </div>
  );
}
